import Model from './BaseModel';
import GroupedParentMarket from './GroupedParentMarket';

export default class MarketGroup extends Model {
	resourceName() {
		return 'market_groups';
	}

	fields() {
		return ['name', 'sport'];
	}

	relationships() {
		return {
			grouped_parent_markets: new GroupedParentMarket()
		};
	}

	create(data) {
		return this.makePersistRequest({
			url: this.resourceUrl(),
			method: 'POST',
			data
		});
	}

	update(data) {
		return this.makePersistRequest({
			url: `${this.resourceUrl()}${this.id}`,
			method: 'PATCH',
			data
		});
	}

	updateParentMarkets(data) {
		return this.makePersistRequest({
			url: `${this.resourceUrl()}${this.id}/parent_markets`,
			method: 'PATCH',
			data
		});
	}
}
